module.exports = __webpack_public_path__ + "assets/img/group.3e75c868.svg";